<template>
  <abk-offers-list offers-type="similar"/>
</template>

<script>
import AbkOffersList from '../../components/offers/AbkOffersList'

export default {
  name: 'OffersListSimilar',
  components: { AbkOffersList },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.offers.offers_list_similar.title')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>
